import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_CommunicationNewMessageContainer = _resolveComponent("CommunicationNewMessageContainer")!
  const _component_v_main = _resolveComponent("v-main")!

  return (_openBlock(), _createBlock(_component_v_main, null, {
    default: _withCtx(() => [
      _createVNode(_component_CommunicationNewMessageContainer)
    ]),
    _: 1
  }))
}